import $ from "jquery";

$('.burger').click(function () {
    $('.burger').toggleClass('clicked');
    $('.overlay').toggleClass('show');
    $('nav').toggleClass('show');
    $('body').toggleClass('overflow');
});

$('.overlay, .close-menu-click').click(function () {
    $('.burger').removeClass('clicked');
    $('.overlay').removeClass('show');
    $('nav').removeClass('show');
    $('body').removeClass('overflow');
})